// Dynamic Favicon Manager
// This utility allows changing favicons based on the current movie

export class FaviconManager {
  constructor() {
    this.currentMovie = 'woodlawn'; // Default movie
  }

  // Set favicon for a specific movie
  setMovieFavicon(movieName) {
    this.currentMovie = movieName.toLowerCase();
    this.updateFavicons();
  }

  // Update all favicon links in the document head
  updateFavicons() {
    const movieConfig = this.getMovieConfig(this.currentMovie);

    // Update standard favicon
    this.updateFaviconLink('icon[type="image/x-icon"]', movieConfig.ico);
    this.updateFaviconLink('icon[sizes="32x32"]', movieConfig.png32);
    this.updateFaviconLink('icon[sizes="16x16"]', movieConfig.png16);
    this.updateFaviconLink('link[rel="apple-touch-icon"]', movieConfig.appleTouchIcon);

    // Update theme color to match movie
    this.updateThemeColor(movieConfig.themeColor);

    console.log(`🎬 Favicon updated for movie: ${this.currentMovie}`);
  }

  // Get configuration for each movie
  getMovieConfig(movieName) {
    const configs = {
      bluemiracle: {
        ico: '/favicon.ico',
        png32: '/favicon-32.png',
        png16: '/favicon-16.png',
        appleTouchIcon: '/apple-touch-icon.png',
        themeColor: '#0066CC',
        poster: '/bluemiracle-poster.jpg'
      },
      woodlawn: {
        ico: '/favicon.ico',
        png32: '/favicon-32.png',
        png16: '/favicon-16.png',
        appleTouchIcon: '/apple-touch-icon.png',
        themeColor: '#8B0000',
        poster: '/woodlawn-poster.jpg'
      },
      // Future movies can be added here
      // example: {
      //   ico: '/example-favicon.ico',
      //   png32: '/example-32.png',
      //   png16: '/example-16.png',
      //   appleTouchIcon: '/example-touch-icon.png',
      //   themeColor: '#1E88E5',
      //   poster: '/example-poster.jpg'
      // }
    };

    return configs[movieName] || configs.woodlawn; // Default to woodlawn
  }

  // Update a specific favicon link
  updateFaviconLink(selector, href) {
    const link = document.querySelector(selector);
    if (link) {
      link.href = href;
    }
  }

  // Update theme color meta tag
  updateThemeColor(color) {
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.content = color;
    }
  }

  // Generate favicon from movie poster (future enhancement)
  async generateFaviconFromPoster(posterUrl) {
    // This could use canvas API to generate favicons dynamically
    // For now, we'll use pre-generated ones
    console.log(`🎨 Future feature: Generate favicon from ${posterUrl}`);
  }

  // Get current movie info
  getCurrentMovie() {
    return {
      name: this.currentMovie,
      config: this.getMovieConfig(this.currentMovie)
    };
  }
}

// Export singleton instance
export const faviconManager = new FaviconManager();

// Auto-initialize with current movie
faviconManager.setMovieFavicon('woodlawn');
